import type { Locale } from "date-fns";
import { enUS, ja, fr, ko, ptBR, es, de } from "date-fns/locale";

// Mapping from ISO 639-1 language code to the appropriate date-fns locale object.
export const dateFnsLocaleMap: { [k: string]: Locale } = {
  en: enUS,
  ja: ja,
  fr: fr,
  ko: ko,
  "pt-br": ptBR,
  es: es,
  de: de,
};
